import { action, observable } from 'mobx'
import Polyglot from 'node-polyglot'
import locales from '../locales'

const english = new Polyglot({ phrases: locales.en_US, allowMissing: true })
const spanish = new Polyglot({ phrases: locales.es_US, allowMissing: true })
const tamil = new Polyglot({ phrases: locales.ta_IN, allowMissing: true})

class Lang {
  @observable locale = getCookie('locale') || 'en_US'
  
  @action
  set = locale => {
    if (locale === 'SPANISH') {
      this.locale = 'es_US'
      setCookie('locale', 'es_US')
    } else if(locale === 'TAMIL') {
      this.locale = 'ta_IN';
      setCookie('locale', 'ta_IN');
    } else {
      this.locale = 'en_US'
      setCookie('locale', 'en_US')
    }
  }

  translate = (str, inserts) => {
    if (this.locale === 'es_US') {
      return spanish.t(str || '', inserts || {})
    } else if(this.locale === 'ta_IN') {
      return tamil.t(str || '', inserts || {});
    }
    return english.t(str || '', inserts || {})
  }

  translatePeopleChart = () => this.locale === 'es_US'? 'people-chart-es.png': 'people-chart.png';
}

function getCookie(name) {
  let value = null
	for (let c of document.cookie.split(';')) {
		const [n, v] = c.trim().split('=')
		if (n === name) {
			value = v
		}
	}
	return value
}

function setCookie(name, value) {
	document.cookie = value === null
		? `${name}=; secure; samesite=strict; expires=Thu, 01 Jan 1970 00:00:00 GMT`
		: `${name}=${value}; secure; samesite=strict`
}


export default new Lang()



// WEBPACK FOOTER //
// ./src/stores/lang.js